














































import {Component, Mixins, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import JdhFieldStructure from "@/design-system/forms/shared/JdhFieldStructure.vue"
import JdhInputArea from "@/design-system/forms/shared/JdhInputArea.vue"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
import JdhAttachedModalPopup from "@/design-system/shared/JdhAttachedModalPopup.vue"
import {ActiveProvide} from "@/support/reactive"
import JdhHeightTransition from "@/design-system/shared/JdhHeightTransition.vue"
import JdhValidationProvider from "@/design-system/forms/fields/JdhValidationProvider.vue"
import JdhErrorMessage from "@/design-system/forms/fields/JdhErrorMessage.vue"

/**
 * @status stable
 * @published 5.0.0
 * @changelog 5.0.0 Published.
 * @changelog 5.9.9 Add placeholder slot and prop.
 */
@Component({
    components: {
        JdhErrorMessage,
        JdhValidationProvider,
        JdhHeightTransition, JdhAttachedModalPopup, JdhInputArea, JdhFieldStructure}
})
export default class JdsSelectField extends Mixins(UniqueIdMixin) {
    @Prop() label!: string
    @Prop({default: null}) width!: number
    @Prop({default: '—'}) placeholder!: string
    @Prop() value!: string

    // TODO: Support required here
    @Prop({default: false, type: Boolean}) required!: boolean

    @ActiveProvide('jds.select-field.bus') bus: Vue|null = null
    @ActiveProvide('jds.select-field.value') currentValue: string|null = null
    @ActiveProvide('jds.select-field.portal') portalTarget: string|null = null

    @ActiveProvide('jds.select-field.context') provideContext = true

    @Ref() inputEl!: JdhInputArea

    open = false
    focused = false

    get portalName() {
        return this.$id('portal')
    }


    get rules () {
        return {
            ... (this.required && {required: { allowFalse: false }}),
        }
    }

    beforeMount() {
        this.bus = new Vue()
        this.bus.$on('input', (value: string) => {
            this.$emit('input', value)
            this.open = false
        })
    }

    @Watch('value', {immediate: true, deep: true})
    syncValue() {
        this.currentValue = this.value
    }

    @Watch('portalName', {immediate: true})
    syncPortal() {
        this.portalTarget = this.portalName
    }

    toggleDropdown() {
        this.open = !this.open
    }
}
